export default {
  resource: {
    disabledTip: '広告の長さがこの広告枠の要件を満たしていません',
    checkLabel: '全て選択',
    checkDescribe: '選択されたアセット {count} 個',
    selection: '素材の選択',
  },
  layout: {
    toPage: '更なる編集機能を解放するには、Playturboにアクセスしてください。',
    media: 'メディアチャンネル',
    size: '広告枠のサイズ',
    horVideo: '横型動画',
    squareVideo: '正方形動画',
    verVideo: '縦型動画',
    broadwise: '横型',
    square: '正方形',
    direction: '縦型',
    icon: 'アイコン',
    facebook: 'Facebookストーリーズ',
    dynamic: 'フィード',
    largeImage: 'ビッグイメージ',
    squareImage: '正方形ビッグイメージ',
    horImage: 'ビッグイメージポートレート',
    screenImage: 'スプラッシュ広告',
    way: 'アダプティブメソッド',
    fillBlack: 'すべての余白を埋める',
    outCrop: '余分な部分を切り取る',
    stretchFill: 'すべてを伸ばして埋める',
    dimensions: 'サイズ',
    materialFill: '素材の埋め込み方法',
    fillEdge: '自動埋め込み',
    cropEdge: '自動切り抜き',
    background: 'バックグラウンド',
    color: '単色',
    vague: 'ぼかし',
    image: '画像',
    backgroundColor: '背景色',
    sellColor: 'スマートカラー',
    applyAll: 'すべての素材に適用',
    customLabel: 'カスタム',
    customSize: 'サイズ（必須）',
    customDuration: '時間（必須）',
    inputTips: '動画のサイズは偶数のみ対応しています。',
  },
  export: {
    cancel: 'キャンセル',
    label: 'エクスポート',
    tips: '素材を先に選択してください',
    title: '素材をエクスポート',
    scale: '比率 {ratio}、',
    measurement: 'サイズ {resolution}',
    duration: '、時間 {min} 〜 {max}s',
    content: '選択した素材 {count} 個、エクスポートを確定しますか？',
    success: 'エクスポート タスクは XMPの素材編集に追加されました',
    renderAndBack: 'エクスポートして編集に戻る',
    renderAndClose: 'エクスポートして編集を終了する',
    set: 'エクスポート設定',
  },
}
